import React, { useEffect, useState } from 'react';

const ScrollFixedTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let throttleTimeout = null; // 타이머 저장 변수

    const handleScroll = () => {
      if (throttleTimeout) return; // 이전 타이머가 존재하면 이벤트 실행 X

      throttleTimeout = setTimeout(() => {
        const scrollViewValue = 200;
        setIsVisible(window.scrollY > scrollViewValue);

        throttleTimeout = null; // 타이머 초기화
      }, 100); // 100ms 간격으로 쓰로틀링
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (throttleTimeout) {
        clearTimeout(throttleTimeout);
      }
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className={`scroll-fixed-top-button-wrapper ${isVisible ? 'is-show' : ''}`}>
      <button
        type={'button'}
        className={'button-default scroll-fixed-button'}
        onClick={scrollToTop}
        aria-label={'Scroll to Top'}
      >
        <i className={'icon icon-top-button'} />
      </button>
    </div>
  );
};

export default ScrollFixedTopButton;
